module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header noselect",
    style: ({
      'background': (_vm.type === 'application') ? _vm.headerColors[1] : _vm.headerColors[0]
    })
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n        "), (_vm.type === 'service') ? _c('md-icon', {
    staticClass: "edit-icon",
    nativeOn: {
      "click": function($event) {
        return _vm.goToService(_vm.data.id)
      }
    }
  }, [_vm._v("edit")]) : _vm._e(), _vm._v(" "), _c('md-icon', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeSidebar.apply(null, arguments)
      }
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), (_vm.type === 'application') ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tab-tools"
  }, [_c('div', {
    class: [_vm.showStatus ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.showStatus = true
      }
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    class: [!_vm.showStatus ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.showStatus = false
      }
    }
  }, [_vm._v("\n                Errors\n                "), (_vm.errors && _vm.errors.length > 0) ? _c('i', [_vm._v(_vm._s(_vm.unwatchedErrorsCount))]) : _vm._e()])]), _vm._v(" "), (_vm.showStatus) ? _c('div', [_c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', [_c('md-icon', {
    class: [_vm.data.levelOfFunctioning == 1 ? 'active' : '']
  }, [_vm._v("fiber_manual_record")]), _vm._v(" "), (_vm.data.levelOfFunctioning == 1) ? _c('span', [_vm._v("ONLINE")]) : _c('span', [_vm._v("OFFLINE")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("developers")]), _vm._v(" "), _c('div', _vm._l((_vm.data.developers), function(developer, index) {
    return _c('p', [_vm._v(_vm._s(developer.name) + "\n                        (" + _vm._s(developer.contactMail) + ")")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("customers")]), _vm._v(" "), _c('div', _vm._l((_vm.data.customers), function(customer, index) {
    return _c('p', [_vm._v(_vm._s(customer.name) + " (" + _vm._s(customer.contactName) + ":\n                        " + _vm._s(customer.contactMail) + ")")])
  }), 0)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("services")]), _vm._v(" "), _c('div', _vm._l((_vm.data.services), function(service, index) {
    return _c('div', {
      staticClass: "service-item",
      on: {
        "click": function($event) {
          return _vm.selectService(service)
        }
      }
    }, [_c('md-icon', {
      class: [service.online ? 'active' : '']
    }, [_vm._v("fiber_manual_record")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(service.name))])], 1)
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.showStatus) ? _c('div', _vm._l((_vm.errors), function(message) {
    return (message.isRead == false) ? _c('div', {
      staticClass: "details-block notification-item"
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.toggleMessage(message)
        }
      }
    }, [_c('md-icon', [_vm._v("fiber_manual_record")]), _vm._v(" "), _c('div', {
      staticClass: "service-name"
    }, [_vm._v(_vm._s(message.serviceName))]), _vm._v(" "), (message.show) ? _c('div', [_c('div', {
      staticClass: "time"
    }, [_c('span', [_vm._v("[" + _vm._s(_vm._f("dateFormat")(message.time)) + "]")])]), _vm._v(" "), _c('div', {
      staticClass: "service-message"
    }, [_c('div', {
      staticClass: "topic"
    }, [_vm._v(_vm._s(message.topic))]), _vm._v("\n                            " + _vm._s(message.message) + "\n                        ")])]) : _vm._e()], 1)]) : _vm._e()
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.type === 'service') ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tab-tools"
  }, [_c('div', {
    class: [_vm.showStatus ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.showStatus = true
      }
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    class: [!_vm.showStatus ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.showStatus = false
      }
    }
  }, [_vm._v("\n                Errors\n                "), (_vm.errors && _vm.errors.length > 0) ? _c('i', [_vm._v(_vm._s(_vm.errors.length))]) : _vm._e()])]), _vm._v(" "), (_vm.showStatus) ? _c('div', [_c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', [_c('md-icon', {
    class: [_vm.data.online ? 'active' : '']
  }, [_vm._v("fiber_manual_record")]), _vm._v(" "), (_vm.data.online) ? _c('span', [_vm._v("ONLINE")]) : _c('span', [_vm._v("OFFLINE")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("since")]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("dateFormat")(_vm.data.startOnline)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("latest resp.")]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("dateFormat")(_vm.data.latestResponse)) + "\n                ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("class")]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.data.class) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("location")]), _vm._v(" "), _c('div', _vm._l((_vm.data.urls), function(url) {
    return _c('a', {
      attrs: {
        "href": url
      }
    }, [_vm._v(_vm._s(url) + " ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("version")]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.data.version || '0.0') + "\n                ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("developers")]), _vm._v(" "), _c('div', _vm._l((_vm.data.developers), function(developer, index) {
    return _c('p', [_vm._v(_vm._s(developer.name) + "\n                        (" + _vm._s(developer.contactMail) + ")")])
  }), 0)]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.data.accuracy) ? _c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("accuracy")]), _vm._v(" "), _c('div', [_c('div', [_vm._v("\n                        " + _vm._s(parseFloat(_vm.data.accuracy * 100).toFixed(2) || 0) + "%\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("calls")]), _vm._v(" "), _c('div', [_c('div', [_vm._v("\n                        " + _vm._s(_vm.data.callsCount || 0) + " last 24 hrs\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("Uptime")]), _vm._v(" "), _c('div', [_c('div', [_vm._v("\n                        " + _vm._s(parseInt(_vm.data.uptime) || 0) + "ms\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("response time")]), _vm._v(" "), _c('div', [_c('div', [_vm._v("\n                        " + _vm._s(parseInt(_vm.data.responseTime) || 0) + "ms\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "header noselect"
  }, [_vm._v("\n                    Historical performance\n                    "), _c('md-icon', {
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('showDetailed')
      }
    }
  }, [_vm._v("call_made")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-switcher"
  }, [_c('div', {
    class: [_vm.dataChartKey === 'accuracy' ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.setChartData(_vm.data.id, 'accuracy')
      }
    }
  }, [_vm._v("Accuracy\n                    ")]), _vm._v(" "), _c('div', {
    class: [_vm.dataChartKey === 'responseTime' ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.setChartData(_vm.data.id, 'responseTime')
      }
    }
  }, [_vm._v("Response Time\n                    ")]), _vm._v(" "), _c('div', {
    class: [_vm.dataChartKey === 'serviceState' ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.setChartData(_vm.data.id, 'serviceState')
      }
    }
  }, [_vm._v("Online/Offline\n                    ")]), _vm._v(" "), _c('div', {
    class: [_vm.dataChartKey === 'calls' ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.setChartData(_vm.data.id, 'calls')
      }
    }
  }, [_vm._v("\n                        Calls\n                    ")])]), _vm._v(" "), _c('line-chart', {
    staticClass: "line-chart",
    attrs: {
      "chart-data": _vm.chartData,
      "options": _vm.chartOptions,
      "height": 240
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.showStatus) ? _c('div', _vm._l((_vm.errors), function(message) {
    return (message.isRead == false) ? _c('div', {
      staticClass: "details-block notification-item"
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.toggleMessage(message)
        }
      }
    }, [_c('md-icon', [_vm._v("fiber_manual_record")]), _vm._v(" "), _c('div', {
      staticClass: "service-name"
    }, [_vm._v(_vm._s(message.serviceName))]), _vm._v(" "), (message.show) ? _c('div', [_c('div', {
      staticClass: "time"
    }, [_c('span', [_vm._v("[" + _vm._s(_vm._f("dateFormat")(message.time)) + "]")])]), _vm._v(" "), _c('div', {
      staticClass: "service-message"
    }, [_c('div', {
      staticClass: "topic"
    }, [_vm._v(_vm._s(message.topic))]), _vm._v("\n                            " + _vm._s(message.message) + "\n                        ")])]) : _vm._e()], 1)]) : _vm._e()
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.type === 'notifications') ? _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.data), function(message) {
    return _c('div', {
      class: ['details-block', 'notification-item', (message.isRead) ? 'isread' : 'unread']
    }, [_c('div', [_c('md-icon', {
      staticClass: "check",
      nativeOn: {
        "click": function($event) {
          return _vm.clickOnMessage(message)
        }
      }
    }, [_vm._v("check")]), _vm._v(" "), _c('div', {
      staticClass: "service-name"
    }, [_vm._v(_vm._s(message.serviceName))]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_c('span', [_vm._v("[" + _vm._s(_vm._f("dateFormat")(message.time)) + "]")])]), _vm._v(" "), _c('div', {
      staticClass: "service-message"
    }, [_c('div', {
      staticClass: "topic"
    }, [_vm._v(_vm._s(message.topic))]), _vm._v("\n                    " + _vm._s(message.message) + "\n                ")])], 1)])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "notification-bar"
  }, [_c('md-icon', {
    staticClass: "check-all",
    class: {
      checked: _vm.isAllChecked
    },
    nativeOn: {
      "click": function($event) {
        return _vm.checkAll.apply(null, arguments)
      }
    }
  }, [_vm._v("check")]), _vm._v(" Mark all as read\n    ")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c22b4c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar.vue
// module id = 305
// module chunks = 2